import React from "react";

const LinkedinBrand2 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131598)">
      <path
        d="M16 31.9998C24.8366 31.9998 32 24.8363 32 15.9998C32 7.1632 24.8366 -0.000244141 16 -0.000244141C7.16344 -0.000244141 0 7.1632 0 15.9998C0 24.8363 7.16344 31.9998 16 31.9998Z"
        fill="#0077B5"
      />
      <path
        d="M25.5603 17.2872V23.8836H21.7359V17.7292C21.7359 16.1839 21.1837 15.1286 19.799 15.1286C18.7423 15.1286 18.1145 15.8391 17.8373 16.5271C17.7366 16.7729 17.7106 17.1143 17.7106 17.4591V23.8833H13.8859C13.8859 23.8833 13.9373 13.4599 13.8859 12.3809H17.7109V14.0109C17.7032 14.0237 17.6924 14.0363 17.6855 14.0485H17.7109V14.0109C18.2192 13.2288 19.1256 12.1108 21.1578 12.1108C23.6739 12.1108 25.5603 13.7548 25.5603 17.2872ZM9.88491 6.8363C8.57663 6.8363 7.7207 7.69509 7.7207 8.8234C7.7207 9.92775 8.55182 10.8113 9.83472 10.8113H9.85953C11.1935 10.8113 12.0229 9.92775 12.0229 8.8234C11.9975 7.69509 11.1935 6.8363 9.88491 6.8363ZM7.94802 23.8836H11.7713V12.3809H7.94802V23.8836Z"
        fill="#F1F2F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131598">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LinkedinBrand2;
